// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ProductSortInput-module__radio-wrapper{padding:.5rem 0}.ProductSortInput-module__radio-wrapper:first-of-type{margin-top:1rem}.ProductSortInput-module__radio-wrapper:last-of-type{margin-bottom:1rem}", "",{"version":3,"sources":["webpack://src/components/productList/FiltersList/ProductSortInput/ProductSortInput.module.scss"],"names":[],"mappings":"AAAA,wCACE,eAAA,CAEA,sDACE,eAAA,CAGF,qDACE,kBAAA","sourcesContent":[".radio-wrapper {\n  padding: 0.5rem 0;\n\n  &:first-of-type {\n    margin-top: 1rem;\n  }\n\n  &:last-of-type {\n    margin-bottom: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radio-wrapper": "ProductSortInput-module__radio-wrapper",
	"radioWrapper": "ProductSortInput-module__radio-wrapper"
};
export default ___CSS_LOADER_EXPORT___;
